/**
 * List Schema of StatusCarga
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {StatusCarga} from '@/model/resource/StatusCarga'

/* TODO: review generated schema */
export class ListStatusCargaSchema extends Schema {
  readonly name = 'ListStatusCarga'

  readonly fieldSet: FieldSet<StatusCarga> = {
    idStatusPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    nome: (): FieldComponent => ({
      is: Component.Render,
    }),
    ativo: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(schema.model.ativo),
      },
    }),
  }
}
